import { mergeClasses } from 'src/utils/merge-classes';

import { StarSky } from './star-sky';
import { ButtonLink } from './button-link';
import { Breadcrumbs, type BreadcrumbLink } from './breadcrumbs';

type PageHeroProps = {
  lead: string;
  title: string;
  current: string;
  links: BreadcrumbLink[];
  eyebrow?: string;
  tightBottom?: boolean;
  action?: { to: string; label: string };
};

export function PageHero({
  lead,
  title,
  links,
  action,
  current,
  eyebrow,
  tightBottom = false,
}: PageHeroProps) {
  return (
    <section className={mergeClasses('page-hero', tightBottom && 'tight-bottom')}>
      <StarSky />
      <div className="container">
        <Breadcrumbs links={links} current={current} />
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1>{title}</h1>
        <p className="lead">{lead}</p>
        {action && (
          <div className="hero-actions centered">
            <ButtonLink withArrow to={action.to} variant="blue" label={action.label} />
          </div>
        )}
      </div>
    </section>
  );
}
